import React, { useState } from 'react';
import { useLiveEvents } from '../hooks/useLiveEvents';

export default function PrintJobs() {
  const [jobs, setJobs] = useState([]);
  const [filter, setFilter] = useState('');

  useLiveEvents((event) => {
    if (event.event === 'print_job') {
      setJobs(prev => [event, ...prev].slice(0, 500));
    }
  });

  const filtered = filter
    ? jobs.filter(j =>
        j.document?.toLowerCase().includes(filter.toLowerCase()) ||
        j.device_id?.includes(filter) ||
        j.printer?.toLowerCase().includes(filter.toLowerCase())
      )
    : jobs;

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 20 }}>
        <h2>Print Jobs</h2>
        <input
          value={filter}
          onChange={e => setFilter(e.target.value)}
          placeholder="Filter…"
          style={inputStyle}
        />
        <button onClick={() => setJobs([])} style={clearBtn}>Clear</button>
        <span style={{ color: 'var(--muted)', fontSize: 12 }}>{jobs.length} jobs logged</span>
      </div>

      <div style={{ background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 10 }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ color: 'var(--muted)', fontSize: 12, textAlign: 'left' }}>
              <th style={th}>Device</th>
              <th style={th}>Document</th>
              <th style={th}>Printer</th>
              <th style={th}>Pages</th>
              <th style={th}>Size</th>
              <th style={th}>User</th>
              <th style={th}>Time</th>
            </tr>
          </thead>
          <tbody>
            {filtered.map((j, i) => (
              <tr key={i} style={{ borderTop: '1px solid var(--border)' }}>
                <td style={{ ...td, color: 'var(--muted)', fontSize: 11 }}>
                  {j.device_id?.slice(0, 8)}
                </td>
                <td style={{ ...td, maxWidth: 240, overflow: 'hidden',
                             textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                  {j.document || '—'}
                </td>
                <td style={td}>{j.printer || '—'}</td>
                <td style={td}>{j.pages ?? '—'}</td>
                <td style={{ ...td, color: 'var(--muted)' }}>
                  {j.size_kb ? `${j.size_kb} KB` : '—'}
                </td>
                <td style={td}>{j.user || '—'}</td>
                <td style={{ ...td, color: 'var(--muted)', fontSize: 11 }}>
                  {j.ts ? new Date(j.ts).toLocaleString() : '—'}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {jobs.length === 0 && (
          <div style={{ padding: 60, textAlign: 'center', color: 'var(--muted)' }}>
            No print jobs captured yet. Events appear here in real time.
          </div>
        )}
      </div>
    </div>
  );
}

const th = { padding: '8px 12px', fontWeight: 500 };
const td = { padding: '10px 12px', fontSize: 13 };
const inputStyle = {
  padding: '6px 12px', background: 'var(--surface)',
  border: '1px solid var(--border)', borderRadius: 6,
  color: 'var(--text)', width: 200,
};
const clearBtn = {
  padding: '6px 14px', background: 'var(--surface)',
  border: '1px solid var(--border)', borderRadius: 6,
  color: 'var(--muted)', cursor: 'pointer',
};
